var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaguestarLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 152,
    viewBox: "0 0 141 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13888_19238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2072 16.4138H126.759V109.103L71.5865 136.69L16.4141 109.103L14.2072 16.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.806 12H21.1515C16.0947 12 12 16.539 12 22.1347V105.205C12 109.184 14.107 112.802 17.3828 114.443L66.6226 139.099C69.0238 140.3 71.7668 140.3 74.168 139.099L123.583 114.355C126.859 112.714 128.966 109.104 128.966 105.117V22.1347C128.966 16.539 124.871 12 119.814 12H119.806ZM72.2359 131.903C71.1467 132.447 69.8745 132.447 68.7852 131.903L21.7955 108.455C20.4677 107.791 19.6249 106.43 19.6249 104.933V82.8145L57.2724 101.667L94.9198 120.519L72.2359 131.895V131.903ZM121.333 61.9048L99.8891 51.2257V43.4687C99.8891 42.3799 99.0145 41.4994 97.9411 41.4994H42.3008C41.633 41.4994 41.0844 42.0517 41.0844 42.7242V42.7722C41.0844 43.2445 41.3467 43.6688 41.7681 43.8769L121.333 83.3508V103.876C121.333 105.509 119.814 106.598 118.47 105.934L19.6249 57.1416V23.6156C19.6249 21.4462 21.3661 19.685 23.5129 19.685H117.437C119.583 19.685 121.325 21.4462 121.325 23.6156V61.9048H121.333Z",
    fill: "url(#paint0_linear_13888_19238)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13888_19238",
    x: 0,
    y: 0,
    width: 140.966,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0431373 0 0 0 0 0.419608 0 0 0 0 0.482353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13888_19238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13888_19238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13888_19238",
    x1: 71.6679,
    y1: 140,
    x2: 71.6679,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C6C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480927,
    stopColor: "#0E798B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BC2A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaguestarLogoColor);
export default __webpack_public_path__ + "static/media/leaguestar_logo_color.952c1967f17fe3cc73c8555b934d753e.svg";
export { ForwardRef as ReactComponent };